/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h, Host } from "@stencil/core";
/**
 * Filter Page.
 */
export class VxAnimatedMultiPagePage {
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (h(Host, { key: '7ede02302262d4518d60ae6eb573b5f052d984fb' }, h("div", { key: '35f6c9cd78db62eea36c73cab5a22b2c5fecce0d', class: 'vx-animated-multi-page-page__header' }, h("slot", { key: '95a8d406a4a65130ad4b9f94ac70f542f24e4fdf', name: 'heading' })), h("div", { key: '2582c261990578dc42e711c2e3f485e8355f5938', class: 'vx-animated-multi-page-page__content' }, h("slot", { key: '7bd53eb2de9373eb5c1fdba539d6cc276e82fd45', name: 'content' })), h("div", { key: '210309533a7bf286bd2a71aaf5236c86bd460b6e', class: 'vx-animated-multi-page-page__footer' }, h("slot", { key: '650bc111cd75fbe02b3f95d02634385f53593998', name: 'footer' }))));
    }
    static get is() { return "vx-animated-multi-page-page"; }
    static get encapsulation() { return "scoped"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-animated-multi-page-page.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-animated-multi-page-page.css"]
        };
    }
}
//# sourceMappingURL=vx-animated-multi-page-page.js.map
